import { qsa } from "../utils/dom"

let bound = false

export const initTestimonials = () => {
  if (bound) return
  bound = true

  document.addEventListener("click", (e) => {
    if (e.target.closest(".testimonial__sharing")) return

    const card = e.target.closest("[data-flip-card]")
    if (!card) return

    const wasFlipped = card.classList.contains("is-flipped")
    qsa("[data-flip-card]").forEach((c) => {
      c.classList.remove("is-flipped")
    })
    if (!wasFlipped) card.classList.add("is-flipped")
  })
}
